import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.aufgabe-aktivieren';
import * as api from '../../../clients/veranstaltungen';

@Injectable()
export class VeranstaltungenAufgabeAktivierenEffects {

    AufgabeAktivieren$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_AUFGABE_AKTIVIEREN),
        mergeMap((x: ac.PostAufgabeAktivierenAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postAufgabeAktivieren(x.aufgabeRequest).pipe(
                map((result: any) => {
                    return new ac.PostAufgabeAktivierenErfolgreichAction(result, x.aufgabeRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostAufgabeAktivierenFehlerAction(error, x.aufgabeRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.AdminCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.AdminCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.AdminCommandService);
        }
        return this.service;
    }
}
